module.exports = __webpack_public_path__ + "static/img/banner-bg.9b12db5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-bg.png
// module id = /vJk
// module chunks = 1